module.exports = __webpack_public_path__ + "static/media/eagle.840baa1a.png";